<template>
  <v-card>
    <v-card-title>
      {{ $t("fund.report.minimalRequirements.title") }}
    </v-card-title>

    <v-simple-table class="v-align-top table-no-hover">
      <template #default>
        <tbody>
          <template v-for="(category, index) in categories">
            <tr :key="index">
              <td colspan="5" class="py-4">
                <h3>
                  {{ $t(`minimalRequirementCategory.${index}.name`) }}
                </h3>
              </td>
            </tr>

            <template v-for="requirement in category">
              <tr :key="requirement.id + '-detailsRow'">
                <td colspan="5" class="py-4" style="border-bottom: none">
                  <strong>
                    {{ $t(`minimalRequirement.${requirement.requirementId}.name`) }}
                  </strong>
                  <br />
                  {{ $t(`minimalRequirement.${requirement.requirementId}.description`) }}
                </td>
              </tr>

              <tr :key="requirement.id + '-dataRow'">
                <td width="25%" class="pb-4">
                  <ResponseList :responses="requirement.protocol" />
                  <Feedback :requirement="requirement" />
                </td>
                <td width="25%" class="pb-4">
                  <p>
                    <strong>{{ requirement.result.result }}</strong>
                  </p>
                  <div>
                    <Markdown :value="requirement.result.description" />
                  </div>
                </td>
                <td width="25%" class="pb-4">
                  <Markdown :value="requirement.internalComment" />
                </td>
                <td width="25%" class="pb-4">
                  <Markdown :value="requirement.notReferencedInternalComment" />
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import groupByCategory from "@/utils/Requirements/groupByCategory";
import ResponseList from "@/components/Fund/ResponseList";
import Feedback from "../../../User/Fund/Protocol/Feedback.vue";

export default {
  components: {
    ResponseList,
    Feedback,
  },

  props: {
    requirements: {
      type: Array,
      required: true,
    },
  },

  computed: {
    categories() {
      return groupByCategory(this.requirements);
    },
  },
};
</script>
